module.exports = "<lifeSpaBookingDetail></lifeSpaBookingDetail>"